import { Input } from "@shared/antd/input";
import React from "react";
import { useIntl } from "react-intl";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { NewReadonlyField } from "../../../components/ReadonlyField/new-read-only";

interface FieldConfig {
  propertyName: string;
  labelId: string;
  rows?: number;
  initialValue?: string;
}

interface JobDescriptionSectionProps {
  fields: FieldConfig[];
  form: WrappedFormUtils<any>;
  entityName: string;
  disabled?: boolean;
  dataInstance?: any;
}

export const JobDescriptionSection: React.FC<JobDescriptionSectionProps> = ({
  fields,
  form,
  entityName,
  disabled = false,
  dataInstance,
}) => {
  const intl = useIntl();

  return (
    <>
      {fields.map((f) => (
        <NewReadonlyField
          key={f.propertyName}
          entityName={entityName}
          propertyName={f.propertyName}
          disabled={disabled}
          form={form}
          formItemOpts={{
            style: { marginBottom: "12px" },
            label: intl.formatMessage({ id: f.labelId }),
          }}
          getFieldDecoratorOpts={{
            initialValue: dataInstance?.[f.propertyName],
          }}
          component={Input.TextArea}
          extraProps={{ rows: f.rows || 4 }}
        />
      ))}
    </>
  );
};
